import React, {memo, useCallback} from "react"
import iconStart from "../../assets/images/icons/scenario/play.png"
import iconStop from "../../assets/images/icons/scenario/pause.png"
import {toggleScenarioFooterPopupScreenAction} from "../../store/ui/actions"
import {useRPC} from "../../hooks/rpc"
import {useDispatch, useSelector} from "react-redux"
import {onClickHandler} from "../../utils/onclick"
import {useOutsideDetector} from "../../hooks/outside-detector"
import "./index.scss"

export const ScenarioFooterPopupScreen = memo(function ScenarioFooterPopupScreen() {
    const dispatch = useDispatch()
    const visible = useSelector(state => state.ui.scenarioFooterPopupScreen.visible)
    const selectedScenario = useSelector(state => state.ui.scenarioFooterPopupScreen.selectedScenario)
    const centerAreaRef = useOutsideDetector(true, () => {
        dispatch(toggleScenarioFooterPopupScreenAction(null))
    })
    const [rpc] = useRPC()
    const play = useCallback(() => {
        if (selectedScenario.is_playing) {
            rpc.stopScenario()
        } else {
            rpc.playScenario(selectedScenario.id)
        }
        dispatch(toggleScenarioFooterPopupScreenAction(null))
    }, [selectedScenario, rpc, dispatch])

    if (!visible) {
        return null
    }

    return (
        <div className={"scenario-screen-wrapper"}>
            <div className="footer-scenario-box" ref={centerAreaRef}>
                <span>{selectedScenario.name}</span>
                <div className="footer-scenario-buttons">
                    <div className="footer-scenario-button" {...onClickHandler(play)}>
                        <img src={selectedScenario.is_playing ? iconStop : iconStart} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
})
